import React from 'react'
import Breadcrump from '../../components/Breadcrump'

const Career = () => {
  return (
    <>
    <Breadcrump title='Career'/>
      <section className="ith-career-section py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            
            <div className="ith-career-card text-center p-4 p-md-5">
              <span className="ith-badge-career">Join Our Team</span>
              <h2 className="ith-form-title">Career With Us</h2>
              <p className="ith-form-desc">
                Build your future with ITH Group. We are looking for talented people who want to make an impact in the hydraulic industry.
              </p>

              {/* Form Action points to FormSubmit.co as per your original code */}
              <form 
                id="ithCareerForm" 
                action="https://formsubmit.co/info@ithgroup.in" 
                method="POST" 
                className="mt-4"
                encType="multipart/form-data"
              >
                {/* Hidden input to disable captcha if needed */}
                <input type="hidden" name="_captcha" value="false" />
                
                <div className="row g-4 text-start">
                  <div className="col-md-6">
                    <label className="ith-field-label">Full Name</label>
                    <input name="name" type="text" className="ith-input-custom" placeholder="Your Name" required />
                  </div>
                  
                  <div className="col-md-6">
                    <label className="ith-field-label">Email Address</label>
                    <input name="email" type="email" className="ith-input-custom" placeholder="Your Mail" required />
                  </div>
                  
                  <div className="col-md-12">
                    <label className="ith-field-label">What position are you applying for?</label>
                    <input name="position" type="text" className="ith-input-custom" placeholder="e.g. Sales Manager, Mechanical Engineer" required />
                  </div>
                  
                  <div className="col-md-12">
                    <label className="ith-field-label">Upload CV / Resume</label>
                    <div className="ith-upload-container">
                      <i className="fas fa-file-pdf ith-upload-icon"></i>
                      <input name="attachment" type="file" accept=".pdf,.doc,.docx" required />
                      <p className="ith-upload-text">
                        <strong>Click to upload</strong> or drag and drop<br />
                        <small>PDF, DOC, DOCX (Max 5MB)</small>
                      </p>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <label className="ith-field-label">Cover Letter / Message</label>
                    <textarea name="message" className="ith-input-custom ith-textarea" placeholder="Tell us about your experience..." required></textarea>
                  </div>

                  <div className="col-md-12">
                    <button type="submit" className="ith-btn-submit">
                      Submit Application <i className="fas fa-paper-plane ms-2"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div> 
    </section>
    </>
  )
}

export default Career
